import React from 'react';
import Tooltip from '../common/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useStore } from '../../store/store';
import { PRIMARY_DARK } from '../../constants/constants';
import { allowedChildModels, deriveAgreementType } from '../../utils/recursiveSections';

const selector = (state) => ({
  currentTemplate: state.currentTemplate,
  recursiveModelLabels: state.recursiveModelLabels,
  recursiveSectionRelationships: state.recursiveSectionRelationships,
});

const RecursiveSectionSettings = () => {
  const { currentTemplate, recursiveModelLabels, recursiveSectionRelationships } = useStore(selector);

  if (
    !currentTemplate ||
    currentTemplate.pattern !== 'section' ||
    !currentTemplate.isRecursive
  ) {
    return null;
  }

  const modelName = currentTemplate.recursiveModelName;
  const labelFor = (key) => recursiveModelLabels?.[key] ?? key ?? '—';
  const modelLabel = labelFor(modelName);

  const isOpportunityParent = modelName === 'opportunity';
  const children = isOpportunityParent
    ? null
    : allowedChildModels(recursiveSectionRelationships, deriveAgreementType(currentTemplate), modelName);

  return (
    <div
      style={{
        padding: '10px 16px',
        // Le panneau de gauche est clair : en blanc, le bandeau était invisible.
        borderTop: '1px solid rgba(0,0,0,0.08)',
        color: PRIMARY_DARK,
        fontSize: 13,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <FontAwesomeIcon icon={icon({ name: 'arrow-turn-down-right', style: 'regular' })} style={{ opacity: 0.7 }} />
        <span style={{ opacity: 0.6 }}>Modèle récursif :</span>
        <strong>{modelLabel}</strong>
        <Tooltip
          zIndex={9999}
          title="Section répétée automatiquement : une instance par élément du modèle (ex. un bloc par matériel). Insérez des champs via @."
        >
          <FontAwesomeIcon
            icon={icon({ name: 'circle-info', style: 'regular' })}
            style={{ opacity: 0.6, cursor: 'help' }}
          />
        </Tooltip>
      </div>

      <div style={{ marginTop: 6, opacity: 0.85 }}>
        <span style={{ opacity: 0.6, marginRight: 6 }}>Enfants imbricables :</span>
        {isOpportunityParent ? (
          <em style={{ opacity: 0.6 }}>tous (hors opportunité)</em>
        ) : children.length > 0 ? (
          <strong>{children.map(labelFor).join(', ')}</strong>
        ) : (
          <em style={{ opacity: 0.6 }}>aucun</em>
        )}
      </div>
    </div>
  );
};

export default RecursiveSectionSettings;
